// Auto-generated normalizer for table: Cat_UnidadesOrg
export function tipoUndiadOrganizacionalNormalize(row) {
  const id =
    row.idTipoUnidadOrganizacional ??
    row.IdTipoUnidadOrganizacional ??
    row.idTipoUndiadOrganizacional ??
    row.IdTipoUndiadOrganizacional ??
    0;

  return {
    idTipoUnidadOrganizacional: id,
    idTipoUndiadOrganizacional: id, // Alias para compatibilidad
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
